/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseError } from '../../../shared/errors/Errors';
import { ListPushEvent } from './PushEvent.state';

export const GET_PUSH_EVENTS_REQUEST = 'GET_PUSH_EVENTS_REQUEST';
export const GET_PUSH_EVENTS_SUCCESS = 'GET_PUSH_EVENTS_SUCCESS';
export const GET_PUSH_EVENTS_FAILURE = 'GET_PUSH_EVENTS_FAILURE';

export interface GetPushEventsRequestAction {
	type: typeof GET_PUSH_EVENTS_REQUEST;
}

export interface GetPushEventsSuccessAction {
	type: typeof GET_PUSH_EVENTS_SUCCESS;
	pushEvents: ListPushEvent[];
}

export interface GetPushEventsFailureAction {
	type: typeof GET_PUSH_EVENTS_FAILURE;
	error: BaseError | null;
}

export type PushEventActionTypes = GetPushEventsRequestAction | GetPushEventsSuccessAction | GetPushEventsFailureAction;
